/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2025 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
import * as o from "react";
import { validateChildren as t } from "../utils/index.mjs";
import i from "./base/ConfigurationComponent.mjs";
import { MapShapeLayerTooltip as m } from "./ShapeLayerTooltip.mjs";
const p = (e) => /* @__PURE__ */ o.createElement(i, { type: "shape", ...e });
p.displayName = "MapShapeLayer";
p.propTypes = {
  children: function(e, r, a) {
    return t(e, r, a, m);
  }
};
export {
  p as MapShapeLayer
};
